<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="viewBox"
    fill="none"
    :xmlns="xmlns"
    :class="icon"
    @click="onClick"
  >
    <path
      v-if="icon === 'angle-up'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 8.74228e-07C10.632 9.29482e-07 11.2314 0.245831 11.6359 0.670972L19.5068
        8.94312C20.2593 9.73407 20.137 10.9094 19.2335 11.5682C18.33 12.227 16.9875 12.1199
        16.2349 11.329L10 4.77617L3.76509 11.329C3.0125 12.1199 1.66999 12.227 0.766493
        11.5682C-0.137002 10.9094 -0.259341 9.73407 0.493241 8.94311L8.36408
        0.670972C8.76859 0.245831 9.36796 8.18973e-07 10 8.74228e-07Z"
      :fill="color"
    />
    <path
      v-else-if="icon === 'angle-down'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 12C9.36796 12 8.76859 11.7542 8.36408 11.329L0.49324 3.05689C-0.25934 2.26593 -0.137001
       1.09064 0.766493 0.431804C1.66999 -0.227036 3.0125 -0.119935 3.76509 0.671019L10
       7.22383L16.2349 0.671019C16.9875 -0.119935 18.33 -0.227036 19.2335 0.431804C20.137 1.09064
       20.2593 2.26593 19.5068 3.05689L11.6359 11.329C11.2314 11.7542 10.632 12 10 12Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '30',
    },
    viewBox: {
      type: String,
      default: '0 0 30 30',
    },
    xmlns: {
      type: String,
      default: 'http://www.w3.org/2000/svg',
    },
    icon: {
      type: String,
      required: true,
      validator: (value) => ['angle-up', 'angle-down'].includes(value),
    },
    color: {
      type: String,
      default: 'black',
    },
  },
  data() {
    return {};
  },
  methods: {
    onClick() {},
  },
};
</script>

<style scoped lang="stylus">
</style>
